export const environment = {
  blogsApiBaseUrl: '/services'
};